import { FunctionComponent, useEffect } from "react";
import { ProfileHeader } from "@App/Components/ProfileHeader";
import { Booking } from "@App/Components/Booking";
import { ProfileDetails } from "@App/Components/ProfileDetails";
import { Reviews } from "@App/Components/Reviews";
import { TriangleDivider } from "@App/Components/TriangleDivider";
import { ContactUs } from "@App/Components/ContactUs";
import { Loader } from "@App/Components/Loader";
import { State } from "@App/state";
import { useSelector } from "react-redux";
import { useScrollToTop } from "@App/hooks/useScrollToTop";
import { ServiceFAQs } from "@App/Components/ServiceFAQs";
import { Slot } from "@App/types";
import {
  ServiceIsVehicleReturn,
  ServiceShouldDisplayReviews,
} from "@App/utils/conditionals/services";
import { FeedbackHint } from "@App/Components/Partials/FeedbackHint";
import {
  OrganizationIsALD,
  OrganizationIsMARA,
  OrganizationIsMeinAuto,
} from "@App/utils/conditionals/organization";
import { VehicleReturnTOS } from "@App/Components/ClientSpecific/MeinAuto/VehicleReturnTOS";
import { getConfig } from "@App/utils/getConfig";

export type ProfileProps = {
  onSubmit?: (slot: Slot) => void;
  embedded?: boolean;
};

export const Profile: FunctionComponent<ProfileProps> = ({
  embedded = false,
  onSubmit,
}: ProfileProps) => {
  useScrollToTop();

  const service = useSelector((state: State) => state.orders.service);
  const garage = useSelector((state: State) => state.orders.garage);
  const organization = useSelector((state: State) => state.orders.organization);

  useEffect(() => {
    const id = crypto.randomUUID();
    {
      garage?.id && window.sessionStorage.setItem(`correlationID${garage?.id}`, `${id}`);
    }
  }, [garage]);

  // Redirect back to the start if parameters are missing.
  // const {redirectOnMissingParams} = useRedirectBack()
  // const location = useLocation()
  // useEffect(() => {
  //     redirectOnMissingParams(['garage', 'service'], location.pathname.substring(0, location.pathname.indexOf('/werkstaetten')))
  // }, [])

  if (!service || !garage) {
    return (
      <div className="h-screen w-screen grid place-items-center">
        <Loader />
      </div>
    );
  }

  // Read the organization config to determine whether reviews should be shown.
  const config = getConfig(organization);
  const orgShouldShowReviews = config.reviews.show;

  return (
    <div>
      <ProfileHeader
        garage={garage}
        displayReviews={ServiceShouldDisplayReviews(service) && orgShouldShowReviews}
      />
      <Booking onSubmit={onSubmit} />
      {(OrganizationIsMeinAuto(organization) || OrganizationIsMARA(organization)) &&
        ServiceIsVehicleReturn(service) && <VehicleReturnTOS />}
      <ProfileDetails />
      {ServiceShouldDisplayReviews(service) && orgShouldShowReviews && <Reviews />}

      {!embedded && (
        <section className="bg-neutral-100 pb-10">
          <TriangleDivider direction={"right"} background={"bg-white"} />
          <div className="container md:flex gap-10 mt-10">
            {!OrganizationIsALD(organization) && (
              <div className="w-full md:w-1/2">
                <ServiceFAQs />
              </div>
            )}
            <div className="w-full md:w-1/2">
              <ContactUs imageHidden={OrganizationIsALD(organization)} />
              {!OrganizationIsALD(organization) && (
                <div className={"mt-8"}>
                  <FeedbackHint />
                </div>
              )}
            </div>
          </div>
        </section>
      )}
    </div>
  );
};
